import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Helper } from "../../core/util/helper";
import { Config } from "../../core/config/config";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Grid } from "../../core/components/grid";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { DialogHelper } from "../../core/util/dialogHelper";
import { TimeType, TimeTypeProps } from "./timeType";
import { EventType } from "../../../siteManagement/eventManager";
import { Entity } from "../../core/components/commonApp";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class EditTimeTypes extends React.Component<any, EditTimeTypesState>{
    private gridOptions: kendo.ui.GridOptions;
    private translations: StringKeyDictionary<string>;
    private initialized: boolean = false;
    constructor(props) {
        super(props);
        this.state = {
            gridData: []
        }
        this.translations = props.context.translations;
        this.initApp();
        this.setEvents();
    }

    private initApp = async () => {
        try {
            const results = await Promise.all([this.getGridData()]);
            this.gridOptions = {
                sortable: true,
                pageable: true,
                groupable: false,
                filterable: false,
                selectable: true,
                resizable: true,
                scrollable: true,
                columns: [
                    {
                        field: "Displayname",
                        title: this.translations["Standard.Designation"]
                    },
                    {
                        field: "AllowAfterSign",
                        title: this.translations["WebSMS.ServiceReport.EditAfterSign"],
                        template: "# if(data.AllowAfterSign == 1) {# <div class='grid-icon-custom-center' style='color:green'><i class='fal fa-check'></i></div> #} else {#  <div class='grid-icon-custom-center' style='color:red'><i class='fal fa-times'></i></div> #}#"
                    }
                ]
            };
            this.initialized = true;
            this.setState({ gridData: results[0] })
        } catch (ex) {
            console.error(ex.message)
        }
    }
    private setEvents = () => {
        General.Events.bind(EventType.Custom, (data: { cmd: string, data: any }) => {
            switch (data.cmd) {
                case ("reloadTypes"):
                    this.reloadGridData();
                    break;
            }
        });
    }
    private getGridData = (): Promise<TimeTypeEntity[]> => {
        return new Promise<TimeTypeEntity[]>(async (resolve, reject) => {
            const data = await HTTPService.get<TimeTypeEntity[]>("TimeType/GetAllTimeTypes")
            resolve(data);
        })
    }

    private reloadGridData = async () => {
        const data = await this.getGridData();
        this.setState({ gridData: data });
    }


    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [
            {

                caption: Config.translations.newLabel,
                enabled: true,
                type: ToolBarStandardButtonType.NEW
            },
            {
                caption: Config.translations.editLabel,
                enabled: true,
                type: ToolBarStandardButtonType.EDIT
            },
            {
                caption: Config.translations.deleteLabel,
                enabled: true,
                type: ToolBarStandardButtonType.DELETE
            }
        ];

        const customButtons: Array<GridCustomToolBarButton> = [];
        customButtons.push({
            id: "copyDefaultTimeTypes", enabled: this.props.entity.RecordRight.CanWrite, caption: Helper.getTranslation("WebSMS.GeneralSettings.TimeTypes.TakeOverDefaultTimeTypes"), iconClass: "fa-solid fa-copy", autoEnabledOnRecordSelected: false
        });
        let css= `#editTimeTypes .k-grid-container{max-height: 500px}`;
        return (
            <div className="flex-container">
                <style>
                    {css}
                </style>
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="editTimeTypes"
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onStandardClick}
                    customButtons={customButtons}
                    onClickCustomButton={this.handleClickCustomButton}
                />
            </div>
        );
    }

    private onStandardClick = (type: ToolBarStandardButtonType, dataItem: TimeTypeEntity) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.openSheet(dataItem.Id);
                break;
            case ToolBarStandardButtonType.NEW:
                this.openSheet();
                break;
            case ToolBarStandardButtonType.DELETE:
                this.delete(dataItem.Id).then(() => {
                    this.reloadGridData();
                });
                break;
        }
    }

    handleClickCustomButton = (id: string) => {
        if (id === "copyDefaultTimeTypes") {
            this.copyDefaultTimeTypes();
        }
    }

    private copyDefaultTimeTypes = async () => {
        if (await DialogHelper.confirm(Helper.getTranslation("WebSMS.GeneralSettings.TimeTypes.Msg.RealyCreate"))) {
            let result = await HTTPService.post<JsonResultClass>("TimeType/CopyDefaultTimeTypesToDynamicTimeTypes");
            if (result.Code == 0) {
                this.reloadGridData();
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"))
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private openSheet = async (id: string = null) => {
        let url = "TimeType/GetTimeTypeById";
        if (!Helper.isNullOrEmpty(id)) {
            url += `?id=${id}`;
        }
        url = encodeURI(url);
        let results = await Promise.all([HTTPService.get<JsonResultClass<TimeTypeEntity>>(url), Helper.getMetaData("timeType")]);
        if (results[0].Code == 0) {
            const props: TimeTypeProps = {
                context: {
                    contextType: "timeType"
                },
                dataSources: null,
                entity: results[0].Data,
                isWindow: false,
                metadata: results[1],
                title: "",
                delete: this.delete,
                closeAfterSave: false
            }
            const sheet = General.Sheet.Manager.createSheet();
            sheet.show(() => {
                sheet.mountContent(TimeType, props);
            });
            sheet.bind(SheetEventType.Close, this.reloadGridData);
        } else {
            NotificationHelper.showErrorMessage(results[0].Message);
        }
    }

    private delete = async (id: string) => {
        const isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            const result = await HTTPService.get<JsonResultClass>(`TimeType/DeleteTimeType?id=${id}`);
            if (result.Code == 1) {
                NotificationHelper.showErrorMessage(result.Message);
            }
            return (result.Code == 0);
        } else {
            return false;
        }
    }

    render() {
        const grid = this.initialized ? this.createGrid() : null;
        return grid;
    }

}
interface TimeTypeEntity extends Entity {
    Id: string;
    Type: number;
    Category: "Work" | "Travel" | "Break";
    AllowAfterSign: boolean;
    Translations: {};
    Displayname: string;
}
interface EditTimeTypesState {
    gridData: TimeTypeEntity[];
}